import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  @Input() border: String; // Defines the requirement of the border
  @Input() placeholder: String; // Defines the placeholder for the search
  @Input() disableSearch = false; // Defines the requirement of search component
  @Input() bindModelData: any; // Binds the data of the search component
  @Input() showClearButton = false; // Show or hide clear button
  @Input() inputWidth?: number;
  @Output() bindModelDataChange: EventEmitter<any> = new EventEmitter(); // Emits the event of data change
  @Output() enterPressed: EventEmitter<any> = new EventEmitter(); // Emits the event when enter is hit
  @Output() clearSearch: EventEmitter<any> = new EventEmitter();
  @Output() searchTermData: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  updateData(event) {
      this.bindModelData = event;
      this.bindModelDataChange.emit(event);
  }

  searchStringUpdated($event) {
      if ($event.charCode === 13) {
          this.enterPressed.emit(this.bindModelData);
      }
  }

  clearSearchTerm() {
    this.bindModelData = '';
    this.updateData('');
    this.clearSearch.emit('');
  }

  searchData() {
    this.searchTermData.emit();
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/search/search.component.ts